import { IonSkeletonText } from '@ionic/react';

interface PageTitleProps {
  children: React.ReactNode;
  loading?: boolean;
  className?: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  children,
  loading = false,
  className = ''
}) => {
  if (loading) {
    return (
      <div className={`px-4 py-3 ${className}`}>
        <IonSkeletonText
          animated
          style={{ width: '60%', height: '28px' }}
        />
      </div>
    );
  }

  return (
    <h1 className={`text-2xl font-bold px-4 py-3 text-white ${className}`}>
      {children}
    </h1>
  );
};